<template>
    <div>
        <a href="#" @click.prevent="openModal()" :title="lnkText" class="btn btn-link text-muted"><i class="far fa-flag m-r-10"></i>{{ lnkText }}</a>

        <div id="complaint_modal" class="modal fade text-left" tabindex="-1" role="dialog" aria-labelledby="adComplaintModal" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                        <h4 class="modal-title">{{ lnkText }}</h4>
                    </div>
                    <div class="modal-body">
                        <p class="text-muted">Preencha os campos abaixo com os motivos para a denúncia deste anúncio. Iremos analisar sua denúncia e voltamos a entrar em contato com nossa decisão final, assim como quais ações serão tomadas.</p>

                        <div class="row m-t-30">
                            <div class="col-xs-12 col-sm-6">
                                <div class="form-group" v-bind:class="{'has-error': errors.has('reason')}">
                                    <label class="control-label" for="reason">Motivo</label>
                                    <select name="reason" v-validate="'required'" v-model="reason" class="form-control">
                                        <option value="">Selecione uma opção</option>
                                        <option value="not_trustable">Não confiável</option>
                                        <option value="expired">Anúncio Expirado</option>
                                        <option value="others">Outros</option>
                                    </select>
                                    <span class="help-block text-left" v-show="errors.has('reason')">
                                        <strong>{{ errors.first('reason') }}</strong>
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-xs-12">
                                <div class="form-group" v-bind:class="{'has-error': errors.has('text')}">
                                    <label class="control-label" for="text">Descrição</label>
                                    <textarea name="text" class="form-control" v-validate="'required'" cols="30" rows="10" v-model="text"></textarea>
                                    <span class="help-block text-left" v-show="errors.has('text')">
                                        <strong>{{ errors.first('text') }}</strong>
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div v-if="send_error" class="alert alert-danger m-b-0">
                            Ocorreu um erro ao enviar esta denúncia. Por favor, atualize a página e tente novamente!
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button @click="sendComplaint()" id="complaint-btn" type="button" data-style="expand-right" class="btn btn-primary waves-effect waves-light ladda-button">
                            <span class="ladda-label">Enviar</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    var Ladda = require('../../../../../../legacy/node_modules/ladda');
    export default {
        props: ['fk_property', 'fk_roommate'],
        data: function () {
            return {
                reason: '',
                text: '',
                send_error: false,
            }
        },
        computed: {
            lnkText: function () {
                if (typeof this.fk_roommate !== typeof undefined)
                    return 'Denunciar este perfil';
                else
                    return 'Denunciar este anúncio';
            }
        },
        methods: {
            openModal: function () {
                this.text = '';
                this.reason = '';
                this.$validator.reset();
                $('#complaint_modal').modal('show');
            },
            sendComplaint: function () {
                let _this = this;
                let l = Ladda.create( document.querySelector('#complaint-btn') );
			    l.start();
                let obj = {reason: this.reason, text: this.text};
                if (this.fk_property)
                    obj.fk_property = this.fk_property;
                if (this.fk_roommate)
                    obj.fk_roommate = this.fk_roommate;

                this.$validator.validateAll().then(function (res) {
                    if (!res) {
                        l.stop();
                        return;
                    }
                    axios.post('/ad-complaint/send-complaint', obj).then(function (res) {
                        l.stop();
                        _this.send_error = false;
                        $('#complaint_modal').modal('hide');
                        setTimeout(() => {
                            if(res.data == 'duplicate')
                                window.App.warning('Sua denúncia já se encontra em nossos registros. Vamos analisá-la o mais rápido possível');
                            else
                                window.App.success('Denúncia enviada com sucesso. Vamos analisar sua denúncia e te dar uma resposta o quanto antes.');
                        }, 600);
                    }).catch(function (err) {
                        l.stop();
                        _this.send_error = true;
                    });
                });
            }
        },
        created: function () {
            this.$validator.localize('pt_BR', {
				messages: {
					required: 'Este campo é obrigatório.',
				},
			});
        }
    }
</script>
